// extracted by mini-css-extract-plugin
export default {"banner":"banner_banner__VB2nr","bannerContent":"banner_bannerContent__OI0UO","tagline":"banner_tagline__wPLC1","title":"banner_title__-Ja93","subtext":"banner_subtext__rLUcE"};